import React, { Component } from "react";

class TextInput extends Component {
  // this contains a text box that allows user to type in information
  render() {
    return (
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span
            className="input-group-text font-weight-bold"
            id="inputGroup-sizing-default"
          >
            {this.props.textName}
          </span>
        </div>
        <input
          placeholder={this.props.placeholder}
          autoComplete={this.props.autoComplete}
          type={this.props.type}
          className="form-control"
          value={this.props.value}
          onChange={(input) => this.props.onChange(input.target.value)}
        />
      </div>
    );
  }
}
export default TextInput;



// WEBPACK FOOTER //
// ./src/components/text-input/index.js